module.exports = __webpack_public_path__ + "static/media/iv_order_inprogress.ee9af47d.svg";